var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-loading-circle",style:({ height: _vm.height, width: _vm.width, 'border-radius': _vm.radius })})}
var staticRenderFns = []

export { render, staticRenderFns }